export const getToken = (state) => state.entities.users.token;
